import { useContent } from '../../../hooks/use-server-content';
export const useContentFragment = (categoryName: any, aemPath: any) => {
    const [content, getValueByName] = useContent(categoryName, aemPath);
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment;
};
